import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import './CreateReferenceReferralButton.scss';
import { ButtonType, CustomButton } from 'soprasteria-ui-library';

interface ICreateReferenceReferralButton {
    canCreateForwardReferral?: boolean;
}

export const CreateReferenceReferralButton: React.FunctionComponent<ICreateReferenceReferralButton> = ({ canCreateForwardReferral }) => {

    return (
        <>
            {
                canCreateForwardReferral ?
                    <div className="create-referral-button" >
                        <div className="btn-group">
                            <CustomButton buttonText="Skapa ny remiss" buttonType={ButtonType.warning} data-toggle="modal" data-target="#referral-forward-modal" />
                        </div>
                    </div>
                    : null
            }
        </>
    )
}
